import React from 'react'
import getStringsBasedLang from '../../strings/get_strings'

export default function BtnLogout(props) {
    const lang = localStorage.getItem("lang")
    return (
        <button className={`w-32 primary_text_color rounded-2xl border-0 py-2 cursor-pointer ${lang === 'en' ? 'ml-2 xs:m-0 sm:m-0 md:m-0' : ''} ${props.isMobile ? 'bg-green-300' : 'bg-white'}`} onClick={() => props.logoutHandler()} /* onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} */>
            <span>{getStringsBasedLang("login_exit")}</span>
        </button >
    )
}
